import { render, staticRenderFns } from "./Avatar_Large.vue?vue&type=template&id=e583f328&scoped=true&"
import script from "./Avatar_Large.vue?vue&type=script&lang=js&"
export * from "./Avatar_Large.vue?vue&type=script&lang=js&"
import style0 from "./Avatar_Large.vue?vue&type=style&index=0&id=e583f328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e583f328",
  null
  
)

export default component.exports